export default __webpack_public_path__ + "static/media/img-2.35f5f93f.jpg";